export default __webpack_public_path__ + "static/media/unscbg.7a122454.jpg";